/* KONG — Collection cinematic interactions (vanilla, zero-dep)
   - Título kinético (reveal por palabra) + count-up de productos
   - Barra de filtros sticky que condensa a glass
   - Cursor-spotlight en la grid, tilt 3D + sheen holográfico + quick-add magnético
   Delegado en document (sobrevive el re-render AJAX de facetas).
   Respeta prefers-reduced-motion y pointer táctil. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---------- Banner: split título + reveal + count-up ---------- */
  function splitTitle(title) {
    if (!title || title.dataset.kcolSplit) return;
    title.dataset.kcolSplit = '1';
    var textNode = null;
    for (var i = title.childNodes.length - 1; i >= 0; i--) {
      var n = title.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { textNode = n; break; }
    }
    if (!textNode) return;
    var words = textNode.textContent.trim().split(/\s+/);
    var frag = document.createDocumentFragment();
    words.forEach(function (w, idx) {
      var wrap = document.createElement('span');
      wrap.className = 'kcol-w';
      var inner = document.createElement('span');
      inner.style.setProperty('--wi', idx);
      inner.textContent = w;
      wrap.appendChild(inner);
      frag.appendChild(wrap);
      if (idx < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });
    title.replaceChild(frag, textNode);
  }

  function countUp(el) {
    if (!el || el.dataset.kcolDone) return;
    el.dataset.kcolDone = '1';
    var target = parseInt(el.getAttribute('data-count') || el.textContent, 10) || 0;
    if (reduce || target <= 0) { el.textContent = target; return; }
    var start = null, dur = 1100;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target).toLocaleString('es-MX');
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initBanner() {
    var banner = document.querySelector('.kong-col-banner');
    if (!banner) return;
    splitTitle(banner.querySelector('.collection-hero__title'));
    var countEl = banner.querySelector('.kong-col-count__n');
    function fire() { banner.classList.add('is-in'); countUp(countEl); }
    if (!('IntersectionObserver' in window) || reduce) { fire(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { fire(); io.disconnect(); }
    }, { threshold: 0.2 });
    io.observe(banner);
  }

  /* ---------- Filtros sticky → is-stuck ---------- */
  function initSticky() {
    var bar = document.getElementById('main-collection-filters');
    if (!bar) return;
    var container = bar.querySelector('.facets-container') || bar;
    var sentinel = document.createElement('span');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;height:1px;width:1px;';
    bar.parentNode.insertBefore(sentinel, bar);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      container.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    io.observe(sentinel);
  }

  function boot() { initBanner(); initSticky(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* ---------- Interacciones de puntero (solo desktop fino) ---------- */
  if (reduce || !fine) return;
  if (window.__kongColFx) return;
  window.__kongColFx = true;

  var TILT = 7;

  document.addEventListener('mouseover', function (e) {
    var grid = e.target.closest && e.target.closest('#ProductGridContainer');
    if (grid) grid.classList.add('kcol-spot');
  });
  document.addEventListener('mouseout', function (e) {
    var grid = e.target.closest && e.target.closest('#ProductGridContainer');
    if (grid && (!e.relatedTarget || !grid.contains(e.relatedTarget))) grid.classList.remove('kcol-spot');
    var wrap = e.target.closest && e.target.closest('.card-wrapper');
    if (wrap && (!e.relatedTarget || !wrap.contains(e.relatedTarget))) {
      var card = wrap.querySelector('.card');
      if (card) { card.style.setProperty('--kcol-tiltX', '0deg'); card.style.setProperty('--kcol-tiltY', '0deg'); }
    }
    var btn = e.target.closest && e.target.closest('.quick-add__submit');
    if (btn && (!e.relatedTarget || !btn.contains(e.relatedTarget))) btn.style.transform = '';
  });

  document.addEventListener('mousemove', function (e) {
    var grid = e.target.closest && e.target.closest('#ProductGridContainer');
    if (!grid) return;
    var gr = grid.getBoundingClientRect();
    grid.style.setProperty('--kcol-mx', (e.clientX - gr.left) + 'px');
    grid.style.setProperty('--kcol-my', (e.clientY - gr.top) + 'px');

    var wrap = e.target.closest('.card-wrapper');
    if (wrap) {
      var r = wrap.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      var card = wrap.querySelector('.card');
      if (card) {
        card.style.setProperty('--kcol-tiltY', (px * TILT).toFixed(2) + 'deg');
        card.style.setProperty('--kcol-tiltX', (-py * TILT).toFixed(2) + 'deg');
        card.style.setProperty('--kcol-px', ((px + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--kcol-py', ((py + 0.5) * 100).toFixed(1) + '%');
      }
    }

    var btn = e.target.closest('.quick-add__submit');
    if (btn && !btn.hasAttribute('disabled')) {
      var br = btn.getBoundingClientRect();
      var mx = e.clientX - (br.left + br.width / 2);
      var my = e.clientY - (br.top + br.height / 2);
      btn.style.transform = 'translate(' + (mx * 0.18).toFixed(1) + 'px,' + (my * 0.32).toFixed(1) + 'px)';
    }
  });
})();
